export default __webpack_public_path__ + "static/media/one.df9e43e1.png";